export default {
    getEmployabilitySicknessNonValidatedDocumentsDataTableOptions: state => state.employabilitySicknessNonValidatedDocumentsDataTableOptions,
    getEmployabilitySicknessNonValidatedDocumentsRowActions: state => state.employabilitySicknessNonValidatedDocumentsRowActions,
    getEmployabilitySicknessNonValidatedDocumentsHeaderFields: state => state.employabilitySicknessNonValidatedDocumentsHeaderFields,
}
